/**
 * Product Grid Variant Updater
 * ==============================
 * Handles real-time updates when variants are selected in product grid cards:
 * - Updates Black Friday discount badge (hide/show based on SKU)
 * - Shows/hides promo ticker based on SKU match
 * - Updates SKU display
 * - Updates pricing
 * - Changes product card link to include variant ID
 * - Updates border styling (default vs gradient based on offer)
 */

// SKU discount tier lookup (matches sku-matching-discount.liquid)
const SKU_TIERS = {
  50: ['AQG33024HT-25','AQG33012-5','AQS33012HT-5','627-1101-FLS','627-2101-FLS','627-3101-FLS','627-4101-FLS','627-5101-FLS','158-1111-OEM','158-3121-OEM','158-2111-OEM','152-3211-VWR','152-2111-OEM','158-0111-OEM','155-3211-OEM','157-3121-OEM','152-3111-OEM','155-3221-OEM','152-1211-OEM','155-2111-OEM','152-3211-OEM','155-0111-OEM','155-2211-OEM','155-1111-OEM','155-5121-OEM','152-3121-OEM','15N-1111-OEM','152-5221-OEM','155-5221-OEM'],
  25: ['11012-FLS','1101-FLS','1102-FLS','1103-FLS','1116-RLS','1122-RLS','11412-FLS','11422-FLS','1142-FLS','11432-FLS','1143-FLS','11512-FLS','1152-FLS','11532-FLS','1153-FLS','116-11132-FLS','11612-FLS','116-21132-FLS','116-2113-FLS','11622-FLS','1162-FLS','116-31132-FLS','116-3113-FLS','11632-FLS','1163-FLS','116-71132-FLS','116-81132-FLS','116-8113-FLS','116-9113-FLS','11712-FLS','1171-RLS','11722-FLS','1172-RLS','11732-FLS','1173-RLS','11762-FLS','11772-FLS','11782-FLS','1181-RLS','1182-RLS','137-1116-FLS','137-1117-FLS','137-2211-FLS','137-2213-FLS','137-3214-FLS','137-3215-FLS','137-4214-FLS','137-5211-FLS','137-6513-FLS','138-1111-FLS','138-2211-FLS','138-2213-FLS','138-3213-FLS','138-4211-FLS','138-4213-FLS','138-5213-FLS','138-6511-FLS','138-6513-FLS','1501016-FLS','1501018-FLS','1501021-FLS','1501024-FLS','1501029-FLS','1501030-FLS','1501031-FLS','1501033-FLS','1501038-FLS','1501040-FLS','1519016-FLS','1519021-FLS','1519024-FLS','1519029-FLS','1519030-FLS','1519031-FLS','1519038-FLS','152-0111-OEM','152-1111-OEM','152-3221-OEM','152-5121-OEM','152-7121-OEM','152-B191-FLS','152-C191-FLS','1551040-FLS','155-1211-OEM','155-3111-OEM','155-3121-OEM','155-7121-OEM','155-B117-FLS','155-B187-FLS','155-B817-FLS','155-C117-FLS','155-C187-FLS','155-C817-FLS','155-J897-FLS','155-K897-FLS','155-L897-FLS','157-0111-OEM','157-1211-OEM','157-2111-OEM','157-2211-OEM','157-3221-OEM','162-1102-OEM','162-2102-OEM','162-4201-OEM','162-4202-OEM','165-1102-OEM','165-1111-FLS','165-1114-FLS','165-2102-OEM','165-2111-FLS','165-4203-OEM','225-1001-RLS','225-4002-RLS','225-4003-RLS','225-4004-RLS','225-4005-RLS','225-4006-RLS','248-4132-OEM','248-4142-OEM','248-4231-OEM','248-4232-OEM','248-4242-OEM','248-5131-OEM','248-5132-OEM','248-5142-OEM','248-5231-OEM','248-5242-OEM','252-1901-OEM','252-1902-OEM','252-1903-OEM','252-1904-OEM','252-1906-OEM','252-1907-OEM','252-1908-OEM','302-1101-FLS','302-2001-FLS','302-2101-FLS','302-4101-FLS','302-4401-FLS','305-1001-FLS','305-1101-FLS','305-1201-FLS','305-2001-FLS','305-2101-FLS','305-2201-FLS','305-4001-FLS','305-4101-FLS','306-1001-FLS','306-1101-FLS','306-4001-FLS','306-4101-FLS','308-2101-FLS','308-4101-FLS','308-5201-FLS','308-6101-FLS','308-6201-FLS','308-8001-FLS','308-9101-FLS','308-9102-FLS','308-9201-FLS','308-9202-FLS','309-2001-FLS','309-4003-FLS','309-5201-FLS','309-6001-FLS','309-8001-FLS','309-9001-FLS','309-9201-FLS','309-9202-FLS','310-2001-FLS','310-4001-FLS','310-5201-FLS','310-6001-FLS','310-8001-FLS','310-9001-FLS','310-9201-FLS','311-1101-FLS','311-1201-FLS','311-2001-FLS','311-2101-FLS','311-2201-FLS','311-4001-FLS','311-4101-FLS','311-4201-FLS','311-5101-FLS','311-6101-FLS','320-1101-FLS','320-2101-FLS','320-2201-FLS','320-4002-FLS','320-4102-FLS','320-5101-FLS','320-5201-FLS','320-6101-FLS','320-6201-FLS','320-9001-FLS','320-9101-FLS','325-3001-FLS','325-3002-FLS','325-4001-FLS','325-4002-FLS','325-5001-FLS','325-5002-FLS','325-6001-FLS','325-6002-FLS','325-8001-FLS','325-8002-FLS','325-9001-FLS','325-9002-FLS','335-1101-FLS','335-1201-FLS','335-2101-FLS','335-2201-FLS','335-3002-FLS','335-3101-FLS','335-3102-FLS','335-3201-FLS','335-3202-FLS','335-4002-FLS','335-4101-FLS','335-4102-FLS','335-5002-FLS','335-6001-FLS','335-8002-FLS'],
  10: [] // 970 SKUs - populated from sku-matching-discount.liquid
};

/**
 * Get discount tier for a given SKU
 * @param {string} sku - Product SKU to check
 * @returns {number} Discount percentage (0, 10, 25, or 50)
 */
function getSkuDiscount(sku) {
  if (!sku) return 0;
  const skuTrimmed = sku.trim();
  
  if (SKU_TIERS[50].includes(skuTrimmed)) return 50;
  if (SKU_TIERS[25].includes(skuTrimmed)) return 25;
  if (SKU_TIERS[10].includes(skuTrimmed)) return 10;
  
  return 0;
}

/**
 * Format money (assumes USD)
 * @param {number} cents - Amount in cents
 * @returns {string} Formatted price
 */
function formatMoney(cents) {
  const dollars = (cents / 100).toFixed(2);
  return `$${dollars.replace(/\.00$/, '')}`;
}

/**
 * Update border styling based on whether product has active offer
 * @param {HTMLElement} productLink - The product card link element
 * @param {boolean} hasOffer - Whether the selected variant has an active offer
 */
function updateBorderStyling(productLink, hasOffer) {
  if (!productLink) return;
  
  if (hasOffer) {
    // Apply gradient border for products with offers
    productLink.style.border = '3px solid transparent';
    productLink.style.background = 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #000000 0%, #1a0000 85%, #E42024 100%) border-box';
    productLink.style.boxShadow = '0 2px 6px rgba(228, 32, 36, 0.25)';
  } else {
    // Apply simple border for products without offers
    productLink.style.border = '2px solid #e0e0e0';
    productLink.style.background = 'white';
    productLink.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.08)';
  }
}

/**
 * Update product card when variant is selected
 * Called from variant selector onChange event
 * @param {HTMLSelectElement} selectElement - The variant selector dropdown
 */
function updateProductVariant(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  if (!selectedOption) return;
  
  // Get variant data from option attributes
  const variantId = selectedOption.value;
  const price = parseInt(selectedOption.dataset.price);
  const comparePrice = parseInt(selectedOption.dataset.comparePrice) || 0;
  const sku = selectedOption.dataset.sku;
  const discountTier = parseInt(selectedOption.dataset.discountTier) || 0;
  const hasOffer = selectedOption.dataset.hasOffer === 'true';
  
  // Find the product card container
  const productCard = selectElement.closest('.grid__item');
  if (!productCard) return;
  
  // Find the product link
  const productLink = productCard.querySelector('.product-card-link');
  
  // 0. Add state class to product card for CSS styling
  if (hasOffer) {
    productCard.classList.add('has-offer');
    productCard.classList.remove('no-offer');
  } else {
    productCard.classList.add('no-offer');
    productCard.classList.remove('has-offer');
  }
  
  // 1. Update SKU Display
  const skuDisplay = productCard.querySelector('#first-sku');
  if (skuDisplay) {
    skuDisplay.textContent = sku + ' ';
    skuDisplay.dataset.skuId = sku;
  }
  
  // 2. Update Black Friday Badge - ONLY show if discount exists
  const badge = productCard.querySelector('[data-badge-element]');
  if (badge) {
    if (discountTier > 0) {
      badge.textContent = `-${discountTier}%`;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }
  
  // 3. Update Border Styling based on offer presence
  updateBorderStyling(productLink, hasOffer);
  
  // 4. Update Pricing and Promo Ticker
  const promoElement = productCard.querySelector('[data-promo-element]');
  const regularPriceElement = productCard.querySelector('.grid-regular-price');
  
  if (discountTier > 0) {
    // Calculate discounted price
    const additionalDiscount = price * (discountTier / 100);
    const finalPrice = price - additionalDiscount;
    
    // Calculate total savings
    let totalSavings = additionalDiscount;
    if (comparePrice && comparePrice > price) {
      const defaultSavings = comparePrice - price;
      totalSavings = defaultSavings + additionalDiscount;
    }
    
    // Show promo ticker with updated values
    if (promoElement) {
      const promoPrice = promoElement.querySelector('[data-promo-price]');
      const promoSavings = promoElement.querySelector('[data-promo-savings]');
      
      if (promoPrice) promoPrice.textContent = formatMoney(finalPrice);
      if (promoSavings) promoSavings.textContent = `Save ${formatMoney(totalSavings)}`;
      
      promoElement.style.display = 'flex';
    }
    
    // Update regular price to show "before discount" label
    if (regularPriceElement) {
      const beforeLabel = regularPriceElement.querySelector('.before-discount-label');
      if (beforeLabel) beforeLabel.style.display = 'block';
      
      const priceRow = regularPriceElement.querySelector('.price-row');
      if (priceRow) {
        const basePrice = priceRow.querySelector('.base-price');
        const compareElement = priceRow.querySelector('.compare-price');
        
        if (basePrice) {
          basePrice.innerHTML = formatMoney(price);
          basePrice.style.textDecoration = 'line-through';
        }
        
        if (comparePrice && comparePrice > price) {
          if (compareElement) {
            compareElement.textContent = formatMoney(comparePrice);
            compareElement.style.display = '';
          } else {
            // Create compare price element if it doesn't exist
            const newCompare = document.createElement('span');
            newCompare.className = 'compare-price';
            newCompare.textContent = formatMoney(comparePrice);
            priceRow.appendChild(newCompare);
          }
        } else if (compareElement) {
          compareElement.style.display = 'none';
        }
      }
    }
  } else {
    // No discount - hide promo, show regular price without strikethrough
    if (promoElement) {
      promoElement.style.display = 'none';
    }
    
    if (regularPriceElement) {
      const beforeLabel = regularPriceElement.querySelector('.before-discount-label');
      if (beforeLabel) beforeLabel.style.display = 'none';
      
      const priceRow = regularPriceElement.querySelector('.price-row');
      if (priceRow) {
        const basePrice = priceRow.querySelector('.base-price');
        const compareElement = priceRow.querySelector('.compare-price');
        
        if (basePrice) {
          basePrice.textContent = formatMoney(price);
          basePrice.style.textDecoration = 'none';
        }
        
        // Show compare at price if on sale
        if (comparePrice && comparePrice > price) {
          if (compareElement) {
            compareElement.textContent = formatMoney(comparePrice);
            compareElement.style.display = '';
          } else {
            // Create compare price element if it doesn't exist
            const newCompare = document.createElement('span');
            newCompare.className = 'compare-price';
            newCompare.textContent = formatMoney(comparePrice);
            priceRow.appendChild(newCompare);
          }
        } else if (compareElement) {
          compareElement.style.display = 'none';
        }
      }
    }
  }
  
  // 5. Update Product Card Link to include variant ID
  if (productLink) {
    const baseUrl = productLink.dataset.productUrl;
    if (baseUrl) {
      productLink.href = `${baseUrl}?variant=${variantId}`;
    }
  }
  
  console.log(`✅ Updated variant: SKU=${sku}, Discount=${discountTier}%, Price=${formatMoney(price)}, HasOffer=${hasOffer}`);
}

/**
 * Prevent variant selector from triggering parent link click
 * Attach to all variant selectors on page load
 */
function initializeVariantSelectors() {
  const selectors = document.querySelectorAll('.product-variant-selector');
  
  selectors.forEach(selector => {
    // Skip if already initialized
    if (selector.dataset.initialized === 'true') return;
    
    // Prevent click events from bubbling to parent link
    selector.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });
    
    // Prevent mousedown from triggering link
    selector.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    });
    
    // Trigger full update for the currently selected option on page load
    // This ensures pricing, SKU, badge, and all data matches the selected variant
    updateProductVariant(selector);
    
    // Mark as initialized
    selector.dataset.initialized = 'true';
  });
  
  console.log(`✅ Initialized ${selectors.length} variant selectors with click prevention`);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('🎬 DOM Content Loaded - initializing variant selectors');
    initializeVariantSelectors();
  });
} else {
  console.log('🎬 Document already loaded - initializing variant selectors');
  initializeVariantSelectors();
}

// Watch for dynamically loaded content (infinite scroll, AJAX loads, etc.)
const observeNewProducts = () => {
  const observer = new MutationObserver((mutations) => {
    let shouldReinitialize = false;
    
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if added node contains variant selectors
          if (node.classList && node.classList.contains('grid__item')) {
            shouldReinitialize = true;
          } else if (node.querySelector && node.querySelector('.product-variant-selector')) {
            shouldReinitialize = true;
          }
        }
      });
    });
    
    if (shouldReinitialize) {
      console.log('🔄 New products detected - reinitializing selectors');
      initializeVariantSelectors();
    }
  });
  
  // Observe the entire document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('👀 MutationObserver watching for new products');
};

// Start observing after a short delay to ensure DOM is ready
setTimeout(observeNewProducts, 1000);

// Re-initialize after any dynamic content load (infinite scroll, filters, etc.)
window.reinitializeVariantSelectors = initializeVariantSelectors;

// Make function globally available
window.updateProductVariant = updateProductVariant;
window.getSkuDiscount = getSkuDiscount;

console.log('✅ Product Grid Variant Updater loaded');
